import React from "react";
import Icon from "@ant-design/icons";


const StaffLocationSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M24.28,45.07h0c-.44,0-.84-.23-1.07-.6l-11.89-19.46c-.06-.11-.33-.65-.33-.65-1.01-2.06-1.53-4.25-1.53-6.52,0-8.17,6.64-14.81,14.81-14.81s14.81,6.64,14.81,14.81c0,2.27-.51,4.46-1.53,6.52l-.28.56s-.05.09-.06.11l-11.88,19.45c-.23.37-.63.6-1.07.6ZM24.28,5.53c-6.79,0-12.31,5.52-12.31,12.31,0,1.88.43,3.7,1.27,5.42l.26.53,10.78,17.64,10.82-17.7.22-.46h0c.84-1.72,1.27-3.54,1.27-5.42,0-6.79-5.52-12.31-12.31-12.31Z" />
        <path d="M24.28,25.25c-4.04,0-7.33-3.29-7.33-7.33s3.29-7.33,7.33-7.33,7.33,3.29,7.33,7.33-3.29,7.33-7.33,7.33ZM24.28,13.09c-2.66,0-4.83,2.17-4.83,4.83s2.17,4.83,4.83,4.83,4.83-2.17,4.83-4.83-2.17-4.83-4.83-4.83Z" />
    </svg>
);

const StaffLocationIcon = (props) => <Icon { ...props } component={ StaffLocationSvg } />;

export default StaffLocationIcon;
